<div class='grid-wrapper'>
    <table mat-table [dataSource]="tableOptions.data" multiTemplateDataRows matSort class="ex-datatable-mat-table ex-datatable-sm">
        @for (col of tableOptions.columns; track col.columnKey) {
            <ng-container [matColumnDef]="col.columnKey!">
                <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="!col.data" class="{{col?.className || ''}}">
                    {{ col.title }}
                </th>
                <td mat-cell *matCellDef="let rowData" class="{{(col?.className || ' ') + ' ' + col?.format?.toLowerCase() }}">
                    @if (isExpanderColumn(col)) {
                        <ap-button [type]="'button'"
                                   [btnType]="'text'"
                                   [compact]="true"
                                   [icon]="expandedRow === rowData ? 'down-chevron-outline' : 'right-chevron-outline'"
                                   [ariaLabel]="expandedRow === rowData ? 'Collapse row' : 'Expand row'"
                                   (onClick)="toggleRow(rowData, $event)">
                        </ap-button>
                    }

                    @if (isDrillDownColumn(col)) {
                        <i class="fa fa-chain"></i>
                    }

                    @if (col.data) {
                        @if (col.formatFn && rowData[col.data] != null) {
                            <span [innerHtml]="col.formatFn(rowData[col.data]) | safeHtml"></span>
                        }
                        {{ !col.formatFn && rowData[col.data] != null ? rowData[col.data] : ''}}{{ rowData[col.data] == null ? (col.defaultContent || '-') : ''}}
                    }
                </td>
            </ng-container>
        }

        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let rowData" [attr.colspan]="displayedColumns.length">
                <div class="p-3">
                    @if (rowData.childLoading) {
                        <ap-loading [colorName]="'a-dark'"></ap-loading>
                    }
                    @if (rowData.children && !rowData.childLoading) {
                        <table mat-table [dataSource]="rowData.children" class="ex-datatable-mat-table ex-datatable-sm child-table">
                            @for (col of childTableOptions.columns; track col.columnKey) {
                                <ng-container [matColumnDef]="col.columnKey!">
                                    <th mat-header-cell *matHeaderCellDef class="{{col?.className || ''}}">
                                        {{ col.title }}
                                    </th>
                                    <td mat-cell *matCellDef="let childRow" class="{{col?.className || ''}}">
                                        @if (isDrillDownColumn(col)) {
                                            <i class="fa fa-chain"></i>
                                        }
                                        @if (col.data) {
                                            @if (col.formatFn && childRow[col.data] != null) {
                                                <span [innerHtml]="col.formatFn(childRow[col.data]) | safeHtml"></span>
                                            }
                                            {{ !col.formatFn && childRow[col.data] != null ? childRow[col.data] : ''}}{{ childRow[col.data] == null ? (col.defaultContent || '-') : ''}}
                                        }
                                    </td>
                                </ng-container>
                            }
                            <tr mat-header-row *matHeaderRowDef="childDisplayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: childDisplayedColumns"></tr>
                        </table>
                    }
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"
            [ngClass]="{ 'totals-row': hasRowStyling('totals-row', row) }"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']; when: isExpandedRow" class="expanded-detail-row"></tr>
    </table>
</div>
